const requestData = {
  apiKey:
    'd0c0614b2a988950d73d16229934cfbb10a933dfc862c5d4a1cec7e033f64de5dd3f5587f31751fd19227eda178a9c34ea13336d3f3c48928ff9675c79ccc6b4',
  daycare: {
    table: 'Personale-måned',
    time: [
      {
        y1: '',
        m1: '',
      },
    ],
    control: ['anc'],
    data: [
      'fuldtid',
      'ls',
      'hoveder',
      'fr10',
      'fr20',
      'fr25',
      'fr30',
      'fr40',
      'fr50',
      'fr60',
      'fr70',
      'fr75',
      'fr80',
      'fr90',
    ],
    selection: [
      {
        name: 'Udvalgte population',
        filters: {
          trs: ['07602'],
          trl: ['K52510', 'K52513', 'K52514'],
          trb: ['1', '2'],
          afl: ['0', '1'],
          omr: ['2', '9'],
          anc: ['00'],
        },
      },
    ],
    options: {
      totals: true,
      outputFormat: 'json',
      actions: [],
      tableName: 'Lønspredning',
      subLimit: 5,
      modelName: 'SIRKA',
      averageSalary: 'fuldtid',
      timeIncreasing: false,
      salary: [
        'gl',
        'ct',
        'tck',
        'tcf',
        'tcg',
        'tco',
        'tca',
        'lt',
        'tlk',
        'tlf',
        'tlg',
        'tlr',
        'tla',
        'tle',
        'er',
        'sy',
        'pb',
        'tj',
        'tci',
        'pbb',
        'pbt',
      ],
    },
  },
  schoolAgeChildcare: {
    table: 'Personale-måned',
    time: [
      {
        y1: '',
        m1: '',
      },
    ],
    control: ['anc'],
    data: [
      'fuldtid',
      'ls',
      'hoveder',
      'fr10',
      'fr20',
      'fr25',
      'fr30',
      'fr40',
      'fr50',
      'fr60',
      'fr70',
      'fr75',
      'fr80',
      'fr90',
    ],
    selection: [
      {
        name: 'Udvalgte population',
        filters: {
          trs: ['07602'],
          trl: ['K32201', 'K32205'],
          trb: ['1', '2'],
          afl: ['0', '1'],
          omr: ['2', '9'],
          anc: ['00'],
        },
      },
    ],
    options: {
      totals: true,
      outputFormat: 'json',
      actions: [],
      tableName: 'Lønspredning',
      subLimit: 5,
      modelName: 'SIRKA',
      averageSalary: 'fuldtid',
      timeIncreasing: false,
      salary: [
        'gl',
        'ct',
        'tck',
        'tcf',
        'tcg',
        'tco',
        'tca',
        'lt',
        'tlk',
        'tlf',
        'tlg',
        'tlr',
        'tla',
        'tle',
        'er',
        'sy',
        'pb',
        'tj',
        'tci',
        'pbb',
        'pbt',
      ],
    },
  },
}
const requestHeaders = {
  Accept: 'application/json',
  'Content-Type': 'text/plain',
}

export { requestData, requestHeaders }
